import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { DialogProps } from './CancelAutoRenewalModal.types';

export const renderCancelAutoRenewalModal = (data: DialogProps) =>
    openPopupHelper({ popupName: popupNames.SUBSCRIPTION_CANCEL_AUTO_RENEWAL_MOBILE, data });
